// Phase 22: the company's default frame color (Admin sets it in Products & pricing), shared by quote lines, Designer and 3D.
let color = "Black";
export const defaultColor = () => color;
export const setDefaultColor = (c) => { color = (c || "").trim() || "Black"; };
